import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';
import { hexToRgba } from '@utils/colorUtils';
import { useEffect } from 'react';

function useAppColors() {
    const { data } = useQuery(queries.colorScheme.getColorScheme());
    const gray = data?.grayTheme === 'WARM' ? {
        gray9: '#110F0D',
        gray8: '#262320',
        gray7: '#504A46',
        gray6: '#6E6864',
        gray5: '#AFA8A5',
        gray4: '#D1CDC9',
        gray3: '#E4E1DE',
        gray2: '#F3F0ED',
        gray1: '#FCFAF8',
        red: '#E81212',
        green: '#6AC917',
        blue: '#2B84E3',
    } : {
        gray9: '#0D0F11',
        gray8: '#202326',
        gray7: '#464B50',
        gray6: '#64696E',
        gray5: '#A5AAAF',
        gray4: '#C9CDD1',
        gray3: '#DEE1E4',
        gray2: '#EDF1F3',
        gray1: '#F8FAFC',
        red: '#FF3750',
        green: '#37DC28',
        blue: '#0084FF',
    };
    const badgeColors = data?.badgeTheme === 'SOFT'
        ? ['#A4CDD5', '#F5F4B1', '#F1B8E4', '#A9E4AD', '#FFCEA9']
        : ['#A5E8FF', '#FFE876', '#FF99CC', '#C2ED4D', '#FB8171'];

    useEffect(() => {
        if (data) {
            document.documentElement.style.setProperty('--color-primary', data.primaryColor);
            document.documentElement.style.setProperty('--color-primary-opacity-65', hexToRgba(data.primaryColor, 0.65));
            document.documentElement.style.setProperty('--color-primary-opacity-28', hexToRgba(data.primaryColor, 0.28));
            document.documentElement.style.setProperty('--color-primary-opacity-20', hexToRgba(data.primaryColor, 0.20));
            document.documentElement.style.setProperty('--color-secondary', data.secondaryColor);
            document.documentElement.style.setProperty('--color-button-text', data.buttonTextColor === 'WHITE' ? '#FFFFFF' : '000000');
            document.documentElement.style.setProperty('--color-icon', data.buttonTextColor === 'WHITE' ? '#FFF' : gray.gray6);
            document.documentElement.style.setProperty('--color-gray9', gray.gray9);
            document.documentElement.style.setProperty('--color-gray8', gray.gray8);
            document.documentElement.style.setProperty('--color-gray7', gray.gray7);
            document.documentElement.style.setProperty('--color-gray6', gray.gray6);
            document.documentElement.style.setProperty('--color-gray5', gray.gray5);
            document.documentElement.style.setProperty('--color-gray4', gray.gray4);
            document.documentElement.style.setProperty('--color-gray3', gray.gray3);
            document.documentElement.style.setProperty('--color-gray2', gray.gray2);
            document.documentElement.style.setProperty('--color-gray1', gray.gray1);
            document.documentElement.style.setProperty('--color-red', gray.red);
            document.documentElement.style.setProperty('--color-green', gray.green);
            document.documentElement.style.setProperty('--color-blue', gray.blue);
            for (let i = 0; i < badgeColors.length; i += 1) {
                document.documentElement.style.setProperty(`--color-badge-${i + 1}`, badgeColors[i]);
            }
        }
    }, [data, gray]);
    return { grayTheme: data?.grayTheme };
}

export default useAppColors;
